module.exports = __webpack_public_path__ + "img/BK_GCC.b7051e6c.png";